<template>
  <div :class="[_isMobile() ? 'mobilePage' : 'wrapper']">
    <a-card v-if="!_isMobile()">
      <div style="width: 500px; margin: 50px auto; text-align: center">
        <h1>请输入识别码继续报名</h1>
        <a-input
          v-model="agentCode"
          placeholder="识别码"
          size="large"
          style="width: 300px"
        ></a-input>
        <a-button size="large" type="danger" @click="getAgentCodeInfo">开始报名</a-button>
        <a-divider></a-divider>
        <span>若无识别码，请联系辅导老师或拨打 4006982989</span>
        <!-- <a-button type="link" @click="$refs.agentCodeSearch.eventId=eventId;$refs.agentCodeSearch.visible=true">点击自助查询</a-button> -->
      </div>
    </a-card>
    <div v-else>
      <p class="wrapperTitle">请输入识别码继续报名</p>
      <a-input placeholder="请输入识别码" v-model="agentCode" class="wrapperInput" />
      <p class="wrappertips">若无识别码，请联系辅导员老师或拨打400-922-6454</p>
      <div class="displayCenter"><a-button  type="primary" @click="getAgentCodeInfo" style="margin: 0 auto;">开始报名</a-button></div>
    </div>
    <!-- <AgentCodeSearchModal ref="agentCodeSearch"/> -->
  </div>
</template>

<script>
import Vue from "vue";
import { getAction, postAction } from "@/api/manage";
import AgentCodeSearchModal from "./modal/AgentCodeSearchModal"
import { mixinDevice } from "@/utils/mixin.js";
export default {
  name: "EventEnter",
  mixins:[mixinDevice],
  components: {
    AgentCodeSearchModal
  },
  data() {
    return {
      agentCode: "",
    };
  },
  created() {
    if(this.$route.query.agentCode){
        this.agentCode = this.$route.query.agentCode
    }
  },
  methods: {
    getAgentCodeInfo() {
      getAction("/teaching/teachingAgentCode/verifyCode?code="+ this.agentCode).then((res) => {
        if (res.success) {
          if(this._isMobile()){
            this.$router.push({path: '/event/notice', query:{id: res.result.eventId, agentCode: this.agentCode}})
          }else{
            this.$router.push({path: '/event/apply', query:{id: res.result.eventId, agentCode: this.agentCode}})
          }
          
        } else {
          this.$message.error(res.message);
        }
      }).catch(e=>{
        let data = e.response.data
        if (data.message.includes("Token失效")) {
          this.$message.error("未登录")
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.mobilePage{
  width: 100%;
  padding: 24px;
  background: #fff;
  box-sizing: border-box;
  .wrapperTitle{
    font-weight: 600;
    font-size: 14px;
    color: #323335;
  }
  .wrapperInput{
    background: #F8F9FA;
    border-color: transparent;
  }
  .wrappertips{
    margin: 8px 0 32px 0;
    font-weight: 400;
    font-size: 12px;
    color: #969AA0;
    line-height: 18px;

  }
}
.wrapper {
  max-width: 1100px;
  margin: 50px auto;
  background: #ffffff;
  padding: 20px;
  // box-shadow: #b48ef1 0 0 10px 3px;
}
</style>